import { ActionRow, ObjectDataRecord } from '@types'
import { getCommandRequestData } from '@helpers'
import { useExecuteCommandMutation } from '@redux/api'

type Props = {
  executeCommand: ReturnType<typeof useExecuteCommandMutation>[0]
  action: ActionRow
  context?: ObjectDataRecord
}

export const executeCommandAction = (props: Props) => {
  const {
    action: { command },
    context,
    executeCommand,
  } = props

  const commandProps = {
    objectCode: command?.objectCode as string,
    commandCode: command?.name as string,
    params: command?.parameters ? getCommandRequestData(command.parameters, context) : undefined,
    body:
      command?.body && command?.httpMethod !== 'GET'
        ? getCommandRequestData(command.body, context)
        : undefined,
    method: command?.httpMethod as string,
  }

  return executeCommand(commandProps).unwrap()
}
